import { useMemo } from 'react';
import { useConfigContext } from '../../../core/formBuilder/configContext';
import { LanguageOption } from './types';

export const useTranslationConfig = () => {
  const { translationConfig, selectedLanguage, setSelectedLanguage } =
    useConfigContext();

  const availableLanguages: LanguageOption[] = useMemo(() => {
    const result = Object.keys(
      translationConfig?.availableTranslations ?? {}
    ).map((key) => {
      return {
        code: key,
        label: key,
        countryCode: key.toLowerCase(),
      };
    });
    result.sort((a: LanguageOption, b: LanguageOption) =>
      a.code == translationConfig?.defaultTranslationName
        ? -1
        : b.code == translationConfig?.defaultTranslationName
        ? 1
        : a.label.localeCompare(b.label)
    );
    return result;
  }, [translationConfig?.availableTranslations]);

  return {
    translationConfig,
    availableLanguages,
    selectedLanguage,
    setSelectedLanguage,
  };
};
